import Vue from 'vue'
import Main from './Main.vue'

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import AOS from 'aos'
import 'aos/dist/aos.css'

import VueMobileDetection from 'vue-mobile-detection'
Vue.use(VueMobileDetection)

Vue.config.productionTip = false




import firebase from "firebase/app"
import "firebase/storage"
import "firebase/auth"
const firebaseConfig = {
  apiKey: "AIzaSyDCeyuibPpZBzPuECYFpryhgOYtgVbvlnU",
  authDomain: "studioestmf.firebaseapp.com",
  projectId: "studioestmf",
  storageBucket: "studioestmf.appspot.com",
  messagingSenderId: "147163408059",
  appId: "1:147163408059:web:77f034376a8a95092b2b9e"
};
firebase.initializeApp(firebaseConfig)


const routes = [
  { path: '/', name:'app' },
  { path: '/admin', name:'admin' },
]
const router = new VueRouter({routes})

Vue.prototype.$firebase = firebase
new Vue({
  router,
  render: h => h(Main),
  created () {
    AOS.init()
  },
}).$mount('#app')
